// Utilities
// Following is for date conversions
export function formatLocalDate(isoString) {
    if (!isoString) return "N/A";
    return new Date(isoString).toLocaleString("en-US", {
      timeZone: "America/New_York",
      dateStyle: "short",
      timeStyle: "short",
    });
  }

export function formatLocalDateShort(isoString) {
    if (!isoString) return "N/A";
    return new Date(isoString).toLocaleDateString("en-US", {
      timeZone: "America/New_York",
      weekday: "short",
      month: "short",
      day: "numeric",
    });
}

export function formatLocalWeekShort(isoString) {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    const endOfWeek = new Date(date);
    endOfWeek.setDate(date.getDate() + 6);

    const startStr = date.toLocaleDateString("en-US", {
      timeZone: "America/New_York",
      month: "short",
      day: "numeric",
    });
    const endStr = endOfWeek.toLocaleDateString("en-US", {
      timeZone: "America/New_York",
      month: "short",
      day: "numeric",
    });
    return `${startStr} - ${endStr}`;
}

/**
 * Turn an ISO‑8601 UTC string (e.g. "2025-04-17T16:30:00Z")
 * into the "YYYY-MM-DDTHH:mm" format that <input datetime-local> expects,
 * adjusted for the user’s local timezone.
 */
export function toInputDateTimeLocal(isoString) {
    if (!isoString) return "";
    const dt = new Date(isoString);
    // subtract the local timezone offset
    const tzOffsetMs = dt.getTimezoneOffset() * 60000;
    const localDt = new Date(dt.getTime() - tzOffsetMs);
    return localDt.toISOString().slice(0, 16);
  }